import { Box, Divider, Skeleton, Stack } from "@mui/material";

export const SearchSkeleton = () => (
  <Stack
    divider={<Divider />}
    sx={{
      mt: 2,
      borderColor: "divider",
      borderRadius: 1,
      borderStyle: "solid",
      borderWidth: 1,
      overflow: "hidden",
    }}
  >
    {Array.from({ length: 5 }).map((_, i) => (
      <Box key={i} sx={{ px: 2, py: 1.5 }}>
        <Stack direction="row" spacing={1.5} alignItems="flex-start">
          <Skeleton
            variant="circular"
            width={20}
            height={20}
            sx={{ mt: 0.25, flexShrink: 0 }}
          />
          <Box sx={{ flex: 1 }}>
            <Skeleton variant="text" width="35%" height={20} />
            <Skeleton variant="text" width="90%" height={16} sx={{ mt: 0.5 }} />
            <Skeleton variant="text" width="65%" height={16} />
          </Box>
        </Stack>
      </Box>
    ))}
  </Stack>
);
